const CONSTANTS = {
    APP_NAME:"Rauru",
    PAGE_URL:"https://rauru.me/",
    ENTRY_TYPES:{
        BASIC: "Basic",
        MODELING_3D: "3D Modeling",
        PIXEL_ART: "Pixel Art",
        WEB_DEVELOPMENT: "Web Development",
        GAME_DEVELOPMENT: "Game Development",
        WRITING: "Writing",
    },
    REGEX:{
        LINK: /^https?:\/\/[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/,
    }
}

export default CONSTANTS;